import { Operator } from '@/models/reports/report-operators';
import { ReportDetails } from '@/models/reports/report-details';
import { SelectItem } from '@/models/reports/select-item';

export class State {
    public allReports: Array<ReportDetails> = new Array<ReportDetails>();
    public allReportsPageNumber: number = 1;
    public allReportsPageSize: number = 25;
    public allReportsTotalPages: number = 1;
    public allReportsTotal: number = 0;
    public allReportsFilterStatus: number | string | null = '';
    public allReportsFrom: string | null = null;
    public allReportsTo: string | null = null;

    public allReportOperators: Array<Operator> = new Array<Operator>();
    public allReportBooleanValues: Array<SelectItem> = new Array<SelectItem>();
    public allReportLogicalOperators: Array<SelectItem> = new Array<SelectItem>();
}
